import { Bot, FolderKanban, Briefcase, Boxes, Megaphone, Handshake, Gauge, BookOpen, Layers, Truck, MapPin, Radar, Crown } from "lucide-react";

export const ICONS = { FolderKanban, Briefcase, Boxes, Megaphone, Handshake, Gauge, BookOpen, Layers, Truck, MapPin, Radar, Crown };
export const AUTONOMY = { auto: "Executes routine actions, reports back", confirm: "Drafts and recommends, asks before acting", human: "Recommends only — a human performs every action" };

export function AgentAvatar({ agent, size = 11, className = "" }) {
  const I = ICONS[agent.icon] || Bot;
  const px = size * 4;
  return (
    <div className={`rounded-2xl flex items-center justify-center text-white flex-shrink-0 relative overflow-hidden ${className}`} style={{ width: px, height: px, background: agent.accent || "var(--ink)" }}>
      <span className="absolute inset-0 opacity-25" style={{ background: "radial-gradient(circle at 30% 20%, #fff, transparent 60%)" }} />
      <I style={{ width: px * 0.45, height: px * 0.45 }} className="relative" />
    </div>);
}

export function PublisherBadge({ agent }) {
  return agent.builtin
    ? <span className="chip border-slate-900/10 text-slate-700 bg-slate-100" data-testid="agent-publisher">Built by Total Operations</span>
    : <span className="chip border-violet-200 text-violet-700 bg-violet-50" data-testid="agent-publisher">{agent.publisher} · ecosystem</span>;
}

export function StatusChip({ status }) {
  const m = { active: "border-teal-200 text-teal-700 bg-teal-50", paused: "border-amber-200 text-amber-700 bg-amber-50", deactivated: "border-slate-200 text-slate-500", available: "border-slate-200 text-slate-500 bg-white" };
  return <span className={`chip uppercase ${m[status] || m.available}`} data-testid="agent-status">{status}</span>;
}
